































import { Vue, Component, Prop } from 'vue-property-decorator';

import DateUtils from '@/utils/DateUtils';

import DiscountOffer from '@/components/molecules/DiscountOffer/DiscountOffer.vue';

@Component({
  components: {
    DiscountOffer
  }
})
export default class OfferBulkCheckboxesItem extends Vue {
  @Prop() data: any;

  get expiration() {
    if (!this.data.expirationDate) return '';

    const daysUntil = DateUtils.getDifferenceDays(
      DateUtils.formatDate(new Date()),
      this.data.expirationDate || ''
    );

    return daysUntil;
  }

  get limitation() {
    return (
      this.data.rules &&
      this.data.rules.filter(
        (rule: any) => rule && rule.name === 'max_redeemed_items'
      )[0]
    );
  }

  get locations() {
    return this.data.locations
      .map((location: { name: string }) => ` ${location.name}`)
      .join();
  }
}
